<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockui">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{this.title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="exported">
          <i class="material-icons"> info </i> <label>The last file exported determines the expected file to be imported back into the tool.</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="exported">
            <i class="material-icons"> info </i>
            <label
              >Warning: Please do not modify the column header in the Excel file. Changes to the header names will cause the re-upload process to
              fail. You are free to alter accept/reject decision within the rows, but the column headers must remain as they are exported.</label
            >
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <ngb-alert *ngIf="message?.length > 0" (close)="message = ''" [type]="type">{{ message }}</ngb-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-file-upload [fileExt]="fileExtension" [maxFiles]="maxFiles" [maxSize]="maxSize" [lastImportedDate]="lastImportedDate" (uploadStatus)="upload($event)"></app-file-upload>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="import()" [disabled]="!(files && files.length > 0)">Import</button>
    </div>
  </div>
</div>
